import Vue from 'vue';
import Router from 'vue-router';
import Plates from '../views/ScanPlates';
import BatteryData from '../views/BatteryData';
import Login from '../views/Login';
import Logout from '../views/Logout';
import Register from '../views/Register';
import RegisterSetPassword from '../views/RegisterSetPassword';
import Dashboard from '../views/Dashboard';
import NewClient from '../views/NewClient';
import TestResult from '../views/TestResult';
import ClientDetails from '../views/ClientDetails';
import PasswordReset from '../views/PasswordReset';
import store from '../store/store';
import PrivacyPolicy from '../views/PrivacyPolicy';
import CatalogModels from '../views/CatalogModels';
import CatalogModelList from '../views/CatalogModelList';
import ClientsList from '../views/ClientsList';
import AddOtherBatteryModel from '../views/AddOtherBatteryModel';
import MyAccount from '../views/MyAccount';
import Quote from '../views/Quote';
import Report from '../views/Report';
import NotFoundPage from '../views/NotFoundPage';
import SetNewPassword from "../views/SetNewPassword";
import Unsubscribe from "../views/Unsubscribe";

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      beforeEnter: (to, from, next) => {
        if (store.state.user.user === null || !store.state.user.user.authenticated) {
          next('/login');
        }
        next('/dashboard');
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        guest: true
      }
    },
    {
      path: '/404',
      name: 'NotFoundPage',
      component: NotFoundPage,
      meta: {
        guest: true
      }
    },

    {
      path: '/logout',
      name: 'Logout',
      component: Logout
    },
    {
      path: '/password-reset',
      name: 'Password reset request',
      component: PasswordReset,
      meta: {
        guest: true
      }
    },
    {
      path: '/set-new-password',
      name: 'Set new password',
      component: SetNewPassword,
      meta: {
        guest: true
      }
    },
    {
      path: '/unsubscribe/:client/:uuid',
      name: 'Unsubscribe',
      component: Unsubscribe,
    },
    {
      path: '/register',
      name: 'Register',
      component: Register,
      meta: {
        guest: true
      }
    },
    {
      path: '/register-set-password',
      name: 'Register Set Password',
      component: RegisterSetPassword,
      meta: {
        guest: true
      },
      beforeEnter: (to, from, next) => {
        if (!store.state.user.registerData) {
          next('/register');
        }
        next();
      }
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      meta: {
        requiresAuth: true
      },
      beforeEnter: (to, from, next) => {
        if (store.state.user.user.isNew === 0) {
          next('/clients-list');
          return;
        }
        next();
      }
    },
    {
      path: '/new-client',
      name: 'New Client',
      component: NewClient,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/clients-list',
      name: 'ClientsList',
      component: ClientsList,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/my-account',
      name: 'MyAccount',
      component: MyAccount,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/scan-plates',
      name: 'Scan Plates',
      component: Plates,
      meta: {
        requiresAuth: true
      },
      beforeEnter: (to, from, next) => {
        if (!store.state.client.currentClient) {
          next('/dashboard');
        }
        next();
      }
    },

    {
      path: '/battery-data',
      name: 'BatteryData',
      component: BatteryData,
      meta: {
        requiresAuth: true
      },
      beforeEnter: (to, from, next) => {
        if (!store.state.client.currentClient) {
          next('/dashboard');
        }
        next();
      }
    },
    {
      path: '/client-details',
      name: 'ClientDetails',
      component: ClientDetails,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/testresult',
      name: 'TestResult',
      component: TestResult,
      meta: {
        requiresAuth: true
      },
      beforeEnter: (to, from, next) => {
        if (!store.state.client.currentClient) {
          next('/dashboard');
        }
        next();
      }
    },
    {
      path: '/catalog',
      name: 'CatalogModels',
      component: CatalogModels,
      meta: {
        requiresAuth: true
      },

      beforeEnter: (to, from, next) => {
        if (!store.state.client.currentClient) {
          next('/dashboard');
        }
        next();
      }
    },
    {
      path: '/catalog-types',
      name: 'CatalogModelList',
      component: CatalogModelList,
      meta: {
        requiresAuth: true
      },
      beforeEnter: (to, from, next) => {
        if (!store.state.client.currentClient) {
          next('/dashboard');
        }
        next();
      }
    },
    {
      path: '/add-another-battery-model',
      name: 'AddOtherBatteryModel',
      component: AddOtherBatteryModel,
      meta: {
        requiresAuth: true
      },
      beforeEnter: (to, from, next) => {
        if (!store.state.client.currentClient) {
          next('/dashboard');
        }
        next();
      }
    },
    {
      path: '/quote',
      name: 'Quote',
      component: Quote,
      meta: {
        requiresAuth: true
      },
      beforeEnter: (to, from, next) => {
        if (!store.state.client.currentClient || !store.state.quote.chosenBatteries) {
          next('/dashboard');
        }
        next();
      }
    },

    {
      path: '/privacy-policy',
      name: 'Privacy Policy',
      component: PrivacyPolicy
    },
    {
      path: '/:id',
      meta: {
        guest: true
      },
      name: 'Report',
      component: Report
    }
    // { path: '*', component: NotFoundPage }
  ],
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    };
  }
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.state.user.user === null) {
      next({
        path: '/login',
        params: { nextUrl: to.fullPath }
      });
      return;
    }
    next();
    return;
  }

  if (to.matched.some(record => record.meta.guest)) {
    if (store.state.user.user === null) {
      next();
      return;
    }
    next({ name: 'Dashboard' });
    return;
  }
  next();
});

export default router;
